import CustomRendering from 'components/Content/CustomRendering/CustomRendering';

export default CustomRendering;
